import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchBlogs } from "./api";

const LatestPosts = () => {

    const [blogs, Setblogs] = useState([]);

    useEffect(() => {
        fetchBlogs()
            .then(data => {
                Setblogs(data.filter(blog => blog.status === 'published').slice(0, 5));
            })
            .catch(err => console.error('Failed to fetch latest posts:', err));
    }, []);

    return (
        <div>
            {blogs.map(blog => (
                <div className='latest' key={blog._id}>
                    <Link to={"/blog/" + blog.slug}>{blog.title}</Link>
                </div>
            ))}
        </div>
    )
}

export default LatestPosts
